import React from "react";
import "./Loader.scss";

interface LoaderProps {
    size?: number;
    color?: string;
    text?: string;
}

const Loader: React.FC<LoaderProps> = ({ size = 40, color = "#09f", text }) => {
    const spinnerStyle = {
        width: `${size}px`,
        height: `${size}px`,
        borderLeftColor: color,
    };

    return (
        <div className="loader-container">
            <div className="spinner" style={spinnerStyle}></div>
            {text && <div className="loader-text">{text}</div>}
        </div>
    );
};

export default Loader;
